<template>
    <el-card class="musteri-form">
        <template slot="header">
            <el-row type="flex" justify="start">
                <div>
                    <el-button icon="el-icon-back" type="text" size="small" @click="golist"></el-button>
                    Müşteri Kayıt
                </div>
            </el-row>
        </template>
        <el-form
                v-loading="loading"
                ref="musteriForm"
                :model="form"
                :rules="rules"
                label-position="left"
                label-width="180px"
                align="left">
            <el-form-item prop="sirket_id" label="Fatura Bilgisi Seçiniz">
                <el-select v-model="form.sirket_id" filterable placeholder="Fatura Bilgisi seciniz">
                    <el-option v-for="s in sirkets" :value="s.id" :label="s.adi" :key="`${s.id}-sirket`"/>
                </el-select>
                <el-button icon="el-icon-plus" @click="sirketFormVisible = true" style="margin-left: 10px"></el-button>
            </el-form-item>

            <el-divider/>

            <el-form-item prop="durumu" label="Müşteri Durumu Seçiniz">
                <el-radio-group v-model="form.durumu">
                    <el-radio-button :label="null">Kiralık</el-radio-button>
                    <el-radio-button label="demo">Demo</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-if="form.durumu" prop="demo_gun_sayisi" label="Demo Gün Sayısı Seçiniz">
                <el-radio-group v-model="form.demo_gun_sayisi">
                    <el-radio-button
                            :label="gun.label"
                            v-for="gun in demoGunleri"
                            :key="gun.value">{{gun.title}}</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-divider/>

            <el-row class="mak-konum">
                <el-form-item label="Konum">
                    <div v-if="form.latitude && form.longitude">
                        <mak-map
                                v-if="showViewMap"
                                view-only
                                :lat="form.latitude"
                                :lng="form.longitude"
                                @update="visibleMap = true"/>
                    </div>
                    <el-card v-else class="add-location" @click.native="visibleMap = true">
                        <el-button type="text">
                            <i class="el-icon-add-location"/>
                            Konum ekle</el-button>
                    </el-card>
                </el-form-item>
            </el-row>

            <el-divider/>

          <el-checkbox v-model="kontrolGirilecek">Kontrol girilecek</el-checkbox>

          <el-divider/>
        </el-form>

        <el-table :data="list" empty-text="Henüz makina eklenmedi!">

            <el-table-column type="expand" width="20">
                <template slot-scope="{ row }">
                    <p><b>Koku ml:</b> {{row.koku_ml}}</p>
                    <p><b>Yoğunluk:</b> {{row.yogunluk}}</p>
                    <p><b>Tutar:</b> {{row.tutar}}</p>
                    <p><b>Not:</b> {{row.not}}</p>
                </template>
            </el-table-column>

            <el-table-column type="index"/>
            <el-table-column prop="makina_adi" label="Makina"/>
            <el-table-column prop="koku_adi" label="Koku"/>
            <el-table-column prop="baslangic_zamani" label="Başlangıç"/>

            <!--     todo       maybe to be removed-->
            <el-table-column v-if="false" prop="koku_ml" label="Koku ml">
                <span slot-scope="{ row }">{{row.koku_ml}} ml</span>
            </el-table-column>
            <el-table-column v-if="false" prop="yogunluk" label="Yoğunluk">
                <span slot-scope="{ row }">{{row.yogunluk}}%</span>
            </el-table-column>
            <el-table-column v-if="false" prop="tutar" label="Tutar">
                <span slot-scope="{ row }">{{row.tutar}}₺</span>
            </el-table-column>
            <!--            maybe to be removed-->

            <el-table-column>
                <el-button slot="header" icon="el-icon-plus" size="mini" @click="mmVisible = true">Yeni Makina
                </el-button>
                <el-button slot-scope="{ $index }" icon="el-icon-delete" size="mini" @click="remove($index)"/>
            </el-table-column>
        </el-table>

        <musteri-makina v-if="false" @add="add" @close="mmVisible = false"/>

        <el-row class="musteri-form-footer">
            <el-button
                    type="success"
                    size="large"
                    :loading="process.loading"
                    :disabled="process.loading || !form.makinalar.length"
                    icon="el-icon-folder-add"
                    @click="submit">Kaydet
            </el-button>
        </el-row>

        <el-dialog title="Yeni Makina Ekle" :visible.sync="mmVisible" width="100%">
            <musteri-makina @add="add" @close="mmVisible = false"/>
        </el-dialog>

        <el-dialog title="Fatura Bilgisi Ekle" :visible.sync="sirketFormVisible" width="100%">
            <sirket-form v-if="sirketFormVisible" :visible="sirketFormVisible" @success="fetchSirket"/>
        </el-dialog>

        <el-dialog :visible.sync="visibleMap" append-to-body fullscreen>
            <mak-map @close="visibleMap = false" @use="locationUse"/>
        </el-dialog>

        <musteri-kontrol-form
            v-if="kontrol"
            v-model="kontrol.visible"
            :musteri-id="kontrol.musteriId"
            :kontrol-zamani="kontrol.kontrolZamani"
            @done="golist"
        />
    </el-card>
</template>

<script>
    import moment from 'moment';
    import Formatter from '@/mixins/Formatter.js';
    import MusteriMakina from '@/components/MusteriMakinaForm.vue'
    import MusteriKontrolForm from '@/components/MusteriKontrolForm.vue'
    import SirketForm from './SirketForm.vue'
    import MakMap from '@/components/MakMap.vue'

    export default {
        name: 'musteri-form',
        components: {MusteriMakina, SirketForm, MusteriKontrolForm, MakMap},
        mixins: [Formatter],
        data() {
            return {
                sirketFormVisible: false,
                mmVisible: false,
                kontrolGirilecek: true,
                process: {
                    makina: false,
                    sirket: false,
                    koku: false,
                    loading: false,
                },
                form: {
                    sirket_id: null,
                    durumu: null,
                    demo_gun_sayisi: 3,
                    makinalar: [],
                    // makina_id: null,
                    // koku_id: null,
                    baslangic_zamani: null,
                    latitude: null,
                    longitude: null,
                    // yogunluk: null,
                },
                rules: {
                    sirket_id: [{required: true, message: 'Fatura Bilgisi seçiniz', trigger: 'change'}],
                    makinalar: [{required: true, message: 'Koku Makinası ekleyiniz', trigger: 'change'}],
                    // koku_id: [ { required: true, message: 'Koku seçiniz', trigger: 'change' } ],
                    // baslangic_zamani: [ { required: true, message: 'Şehir seçiniz', trigger: 'change' } ],
                    // yogunluk: [ { required: true, message: 'Yoğunluk seçiniz', trigger: 'change' } ],
                },
                makinaList: [],
                sirketList: [],
                kokuList: [],
                demoGunleri:  [
                    { label: 3, title: '3 Günlük' },
                    { label: 5, title: '5 Günlük' },
                    { label: 7, title: '7 Günlük' },
                ],
                kontrol: null,
                visibleMap: false,
                showViewMap: true,
            };
        },
        computed: {
            id() {
                return this.$route.params.id;
            },
            loading() {
                const {makina, koku, sirket} = this.process;
                return makina || koku || sirket;
            },
            kokuMapping() {
                return this.kokuList.reduce((res, d) => {
                    res[d.id] = d.adi;
                    return res;
                }, {});
            },
            makinaMapping() {
                return this.makinaList.reduce((res, d) => {
                    res[d.id] = d.adi;
                    return res;
                }, {});
            },
            list() {
                return this.form.makinalar
                    .map((d) => {
                        let a = Object.assign({}, d);
                        a.makina_adi = this.makinaMapping[d.makina_id];
                        a.koku_adi = this.kokuMapping[d.koku_id];
                        return a;
                    });
            },
            sirkets() {
                return this.sirketList.slice()
                    .sort((a, b) => {
                        return a['adi'] - b['adi'];
                    });
            }
        },
        methods: {
            add(makina) {
                const mm = Object.assign({}, makina);
                this.form.makinalar.push(mm);
                this.mmVisible = false;
            },
            remove(ind) {
                this.form.makinalar.splice(ind, 1);
            },
            locationUse(position) {
                if (position) {
                    this.form.latitude = position.lat();
                    this.form.longitude = position.lng();
                    this.visibleMap = false;

                    this.showViewMap = false;
                    setTimeout(() => {
                        this.showViewMap = true;
                    }, 500);
                }
            },
            golist() {
                this.$router.go(-1);
            },
            submit() {
                this.$refs.musteriForm.validate((valid) => {
                    if (valid) {
                        this.create();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            create() {
                this.process.loading = true;
                this.form.baslangic_zamani = moment().format('YYYY-MM-DD HH:mm:ss');
                this.$requests.Musteri.createMusteri(this.form)
                    .then((data) => {
                        this.$refs.musteriForm.resetFields();
                        if (this.kontrolGirilecek) {
                            this.kontrol = {
                                visible: true,
                                musteriId: data.id,
                                kontrolZamani: moment(),
                            };
                        } else {
                            this.golist();
                        }
                        this.$message.success('Musteri kaydi basariyla girildi!');
                    })
                    .catch((e) => {
                        console.error('error creating musteri', e);
                    })
                    .then(() => {
                        this.process.loading = false;
                    });
            },
            fetchMakina() {
                this.process.makina = true;
                this.$requests.Makina.getMakina(this.form)
                    .then((data) => {
                        this.makinaList = data;
                    })
                    .catch((e) => {
                        console.error('error fetching makina list', e);
                    })
                    .then(() => {
                        this.process.makina = false;
                    });
            },
            fetchSirket() {
                this.sirketFormVisible = false;
                this.process.sirket = true;
                this.$requests.Sirket.getSirket()
                    .then((data) => {
                        this.sirketList = data;
                    })
                    .catch((e) => {
                        console.error('error fetching sirket list', e);
                    })
                    .then(() => {
                        this.process.sirket = false;
                    });
            },
            fetchKoku() {
                this.process.koku = true;
                this.$requests.Koku.getKoku()
                    .then((data) => {
                        this.kokuList = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.koku = false;
                    });
            },
        },
        mounted() {
            this.fetchKoku();
            this.fetchMakina();
            this.fetchSirket();
        },
        watch: {
            'form.durumu'() {
                if (this.form.durumu) {
                    this.form.demo_gun_sayisi = 3;
                } else {
                    this.form.demo_gun_sayisi = null;
                }
            },
            'form.sirket_id'(sirketId) {
                if (sirketId) {
                    const sirket = this.sirketList.find(s => s.id === sirketId);
                    if (sirket && sirket.latitude && sirket.longitude) {
                        this.form.latitude = parseFloat(sirket.latitude);
                        this.form.longitude = parseFloat(sirket.longitude);
                    } else {
                        this.form.latitude = null;
                        this.form.longitude = null;
                    }
                } else {
                    this.form.latitude = null;
                    this.form.longitude = null;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .musteri-form {
        .musteri-form-footer {
            margin: 20px 0;
        }

        .el-divider {
            margin: 0 0 25px 0;
            visibility: hidden;
        }

        .mak-konum {
            .add-location {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }
    }
</style>
